import { Link } from "wouter";
import { Rocket } from "lucide-react";

// Selo "Disponível no Ultra" (10/09/2026): marca uma feature fechada pro plano
// Ultra e leva direto ao upgrade. Clicável de propósito — o selo é o funil.
// `plan="profissional"` (15/10/2026, contar preparos): mesmo selo, "Disponível no Profissional", levando ao plano.
export function UltraBadge({
  label,
  size = "sm",
  className = "",
  plan = "ultra",
}: {
  label?: string;
  size?: "sm" | "md";
  className?: string;
  plan?: "profissional" | "ultra";
}) {
  const nome = plan === "profissional" ? "Profissional" : "Ultra";
  return (
    <Link
      href={`/assinar?plan=${plan}`}
      // max-w-full + truncate: em tela estreita (S23, 360px) um rótulo longo
      // vazava pra fora do cartão — o nowrap do selo não cedia.
      className={`inline-flex max-w-full items-center gap-1 rounded-full border border-amber-300 bg-amber-50 text-amber-800 font-semibold whitespace-nowrap hover:bg-amber-100 transition-colors dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-800 ${
        size === "sm" ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
      } ${className}`}
      data-testid={plan === "profissional" ? "pro-badge" : "ultra-badge"}
      title={`Ver o plano ${nome}`}
    >
      <Rocket className={`shrink-0 ${size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"}`} />
      <span className="truncate">{label ?? `Disponível no ${nome}`}</span>
    </Link>
  );
}
